module.exports = __webpack_public_path__ + "static/media/clock-custom.b68e6f0c.svg";